var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisualisationSaveAsAction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_17348_100402)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 32,
    height: 32,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 4.5H19C17.346 4.5 16 5.846 16 7.5V26.5C16.0001 26.6872 16.0526 26.8706 16.1518 27.0294C16.2509 27.1881 16.3927 27.3159 16.5608 27.3981C16.729 27.4803 16.9168 27.5137 17.103 27.4944C17.2892 27.4751 17.4663 27.4039 17.614 27.289L26 20.767L34.386 27.289C34.5335 27.4043 34.7106 27.4757 34.8968 27.495C35.0831 27.5143 35.271 27.4806 35.439 27.398C35.6072 27.3158 35.7489 27.1881 35.8481 27.0293C35.9473 26.8706 35.9999 26.6872 36 26.5V7.5C36 5.846 34.654 4.5 33 4.5ZM34 24.456L26.614 18.711C26.4386 18.5741 26.2226 18.4997 26.0002 18.4995C25.7777 18.4994 25.5616 18.5734 25.386 18.71L18 24.456V7.5C18 6.949 18.449 6.5 19 6.5H33C33.551 6.5 34 6.949 34 7.5V24.456Z",
    fill: "#232F6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_17348_100402",
    x: -4,
    y: -14,
    width: 60,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_17348_100402"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.5525 0 0 0 0 0.56225 0 0 0 0 0.65 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_17348_100402",
    result: "effect2_dropShadow_17348_100402"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_17348_100402",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualisationSaveAsAction);
export default __webpack_public_path__ + "static/media/visualisation-save-as-action.1c0af18b66dfa82c44dc89efb8bac869.svg";
export { ForwardRef as ReactComponent };